import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { AssetsAssetHistoryEntitiesSchemaWithId } from '@iconik-io/iconik-api/src/services/assets';

import type { EntityHistoryReducerAppState } from './types';

const initialState: EntityHistoryReducerAppState = { entityHistory: {} };

export const entityHistorySlice = createSlice({
  name: 'entity_history',
  initialState,
  reducers: {
    setEntityHistory: (
      state,
      action: PayloadAction<{
        entityId: string;
        history: AssetsAssetHistoryEntitiesSchemaWithId;
      }>,
    ) => {
      state.entityHistory[action.payload.entityId] = action.payload.history;
    },
  },
});

export const { setEntityHistory } = entityHistorySlice.actions;

export const assetHistoryReducer = entityHistorySlice.reducer;
